import { createVNode as a, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/CloseOutlinedStandard.js";
import l from "../components/PfIcon.js";
const t = (r, e) => {
  const o = {
    ...r,
    ...e.attrs
  };
  return a(l, n(o, {
    icon: d
  }), null);
};
t.displayName = "CloseOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
